export { default as LawsuitAttachments } from "./LawsuitAttachments";
